import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shipment: {
    description: 'advancedSearch.shipments.filters.shipment',
    defaultMessage: 'Shipment',
    id: 'ju1uGN',
  },
  fulfillments: {
    description: 'advancedSearch.shipments.filters.fulfillments',
    defaultMessage: 'Fulfillments',
    id: 'h45G0z',
  },
  returns: {
    description: 'advancedSearch.shipments.filters.returns',
    defaultMessage: 'Returns',
    id: 'EQeUQ3',
  },
  batches: {
    description: 'advancedSearch.shipments.filters.batches',
    defaultMessage: 'Batches',
    id: 'i8au4U',
  },
});
